import BaseApiService from "../base_api.service";
import { MenuCategoryModel } from "./models/menu_category.model";

class MenuCategoryService extends BaseApiService {
  constructor() {
    super("MenuCategories");
  }
  async getList(companyId: string): Promise<Promise<MenuCategoryModel[]>> {
    return (
      (await this.get<MenuCategoryModel[]>(`/?companyId=${companyId}`)) ?? []
    );
  }
  async getListByStatus(
    companyId: string,
    status: boolean = true,
  ): Promise<Promise<MenuCategoryModel[]>> {
    return (
      (await this.get<MenuCategoryModel[]>(
        `/GetListByStatus?companyId=${companyId}&status=${status}`,
      )) ?? []
    );
  }
  add(
    menuCategoryModel: MenuCategoryModel,
  ): Promise<MenuCategoryModel | undefined> {
    console.error(menuCategoryModel, "service");

    return this.post<MenuCategoryModel>(``, menuCategoryModel);
  }
  update(
    menuCategoryModel: MenuCategoryModel,
  ): Promise<MenuCategoryModel | undefined> {
    console.error(menuCategoryModel, "service");

    return this.put<MenuCategoryModel>(``, menuCategoryModel);
  }
  deleteCategory(id: string): Promise<string | undefined> {
    return this.delete<string>(`?id=${id}`);
  }
}
export default MenuCategoryService;
